export default {
    '99453':{
        desc: 'Monitoring of physiologic parameter(s) (eg, weight, blood pressure, pulse oximetry, respiratory flow rate), initial; set-up and patient education on use of equipment',
        timeframe: '30 days'
    },
    '99454':{
        desc: 'Monitoring of physiologic parameter(s) (eg, weight, blood pressure, pulse oximetry, respiratory flow rate), initial; device(s) supply with daily recording(s) or programmed alert(s) transmission, each 30 days',
        timeframe: '30 days'
    },
    '99457':{
        desc: 'Physiologic monitoring treatment management services, clinical staff/physician/other qualified health care professional time in a calendar month requiring interactive communication with the patient/caregiver during the month; first 20 minutes',
        timeframe: 'calendar month'
    },
    '99458':{
        desc: 'Physiologic monitoring treatment management services, clinical staff/physician/other qualified health care professional time in a calendar month requiring interactive communication with the patient/caregiver during the month; each additional 20 minutes (list separately in addition to code for primary procedure)',
        timeframe: 'calendar month'
    },
    '98975':{
        desc: 'Therapeutic monitoring (eg, respiratory system status, musculoskeletal system status, therapy adherence, therapy response); initial set-up and patient education on use of equipment',
        timeframe: '30 days'
    },
    '98976':{
        desc: 'Therapeutic monitoring (eg, respiratory system status, musculoskeletal system status, therapy adherence, therapy response); device(s) supply with scheduled (eg, daily) recording(s) and/or programmed alert(s) transmission to monitor respiratory system, each 30 days',
        timeframe: '30 days'
    },
    '98980':{
        desc: 'Therapeutic monitoring treatment management services, physician or other qualified health care professional time in a calendar month requiring at least one interactive communication with the patient or caregiver during the calendar month; first 20 minutes',
        timeframe: 'calendar month'
    },
    '98981':{
        desc: 'Therapeutic monitoring treatment management services, physician or other qualified health care professional time in a calendar month requiring at least one interactive communication with the patient or caregiver during the calendar month; each additional 20 minutes (list separately in addition to code for primary procedure)',
        timeframe: 'calendar month'
    },
    // 99091 (interpretation of physiologic data, 30 minutes each 30 days) is not
    // listed. Main's page offered it, but main's own price list (SqlClass
    // $cptCosts) has the eight codes above and no 99091, and the port's CPT
    // catalogue is those eight: an Add Meter under a code with no accrual rule
    // and no price is refused (422 unknown_cpt_code, "not billable"), because a
    // mapping that is saved and then bills nothing would look assigned while it
    // silently stopped accruing. Offering 99091 again needs a billing owner's
    // rule for it in the catalogue first (CptCodeSeeder), not a section that
    // can only fail.
}